import { render, staticRenderFns } from "./CriteriasPropertyFilter.vue?vue&type=template&id=b23ac1b2&scoped=true"
import script from "./CriteriasPropertyFilter.vue?vue&type=script&lang=ts"
export * from "./CriteriasPropertyFilter.vue?vue&type=script&lang=ts"
import style0 from "./CriteriasPropertyFilter.vue?vue&type=style&index=0&id=b23ac1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23ac1b2",
  null
  
)

export default component.exports